import { render, staticRenderFns } from "./Techmenu.vue?vue&type=template&id=7a1bf761&scoped=true&"
import script from "./Techmenu.vue?vue&type=script&lang=js&"
export * from "./Techmenu.vue?vue&type=script&lang=js&"
import style0 from "./Techmenu.vue?vue&type=style&index=0&id=7a1bf761&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a1bf761",
  null
  
)

export default component.exports